<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('AlarmInforecord') }}
      <div class="check_more" v-if="showBack" @click="backLast">{{ $t('returnM') }}></div>
    </div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="formInline.ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              @change="changeParamOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('deviceType')">
            <el-select
              v-model="formInline.specType"
              clearable
              :placeholder="$t('deviceType')"
              :popper-append-to-body="false"
            >
              <template v-for="item of helmetType">
                <el-option
                  v-if="checkDeviceType(item.value)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('alertType')">
            <el-select
              v-model="formInline.alertType"
              clearable
              :placeholder="$t('alertType')"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item of positionType"
                :key="item.alertCode"
                :label="$t(item.alertName)"
                :value="item.alertCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('userNameH')">
            <el-input v-model="formInline.userName" clearable :placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          
          <el-form-item :label="$t('Recordtime')" class="datetime">
            <el-date-picker
              v-model="formInline.searchTimeB"
              :placeholder="$t('startDate')"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="formInline.searchTimeE"
              :placeholder="$t('endDate')"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('serialNumberP')">
            <el-input v-model="formInline.serialNumber" clearable :placeholder="$t('serialNumberP')"></el-input>
          </el-form-item>
          <el-form-item class="btns">
            <el-button type="primary" @click="getList" class="serachBtn" v-preventReClick="1000">{{ $t('query') }}</el-button>
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
            <el-button type="primary" @click="dealAll" class="serachBtn" v-preventReClick="1000" v-has="'sys:new:setting:log:alert:edit'">
              {{ $t('handleButton') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table开始 -->
      <div class="table-box">
        <el-table  :data="tableData" style="width: 100%;" v-loading="loading" @sort-change="sortChange">
          <el-table-column
            type="index"
            :index="indexMethod"
            :label="$t('SerialNo')"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userName" :label="$t('userNameH')" min-width="100" sortable="userName" :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column prop="ouName" :label="$t('mechanism')" min-width="120" sortable="ouName" :sort-orders="['ascending', 'descending']"> </el-table-column>
          <el-table-column prop="serialNumber" min-width="180" :label="$t('serialNumberP')" sortable="serialNumber" :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column prop="specType" min-width="120" :label="$t('deviceType')" sortable="specType" :sort-orders="['ascending', 'descending']">
            <template slot-scope="scope">
              <span>{{ scope.row.specType | helmetType }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="alertType"
            :label="$t('eventH')"
            min-width="120"
            :formatter="fileData"
            sortable="alertType"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="createdTime"
            :label="$t('Recordtime')"
            width="180"
            align="center"
            sortable="createdTime"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="updatedTime"
            :label="$t('updatedTime')"
            width="180"
            align="center"
            sortable="updatedTime"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column prop="updatorName" :label="$t('updatorName')" width="140" sortable="updatorName" :sort-orders="['ascending', 'descending']">
          </el-table-column>
          <el-table-column :label="$t('operationh')" prop="status">
            <template slot-scope="scope">
              <!-- 深色 -->
              <i
                :class="[scope.row.status ? 'ic-Deal' : 'ic-unDeal']"
                class="deal-btn"
                @click="HandleClick(scope.row)"
                v-has="'sys:new:setting:log:alert:edit'"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getCautionList, findAlertType, updateStatus, clearMessage, exportAlert } from '@/api/caution'
import { HELMET_TYPE } from '@/common/enum'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
import { getOus } from '@/api/UserList'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      positionType: [],
      // 事件类型 选择数组
      alertTypeList: [],
      // 查询表单
      formInline: {
        alertType: '',
        userName: '',
        ouName: '',
        searchTimeB: beforeWeekDate()+' 00:00:00',
        searchTimeE: nowDate() + ' 23:59:59',
        specType: '',
        serialNumber: '',
      },
      // table 数据
      tableData: [],
      formLabelWidth: '120px',
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // 查询选择设备类型
      helmetType: HELMET_TYPE,
      // 机构列表
      ouList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      showBack: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['isOnlySupportPosition']),
  },
  methods: {
    backLast() {
      this.$router.go(-1)
    },
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      this.getList()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    fileData(row) {
      // 格式化内容
      for (let item of this.alertTypeList) {
        if (row.alertType === item.alertCode) {
          if (row.data) {
            if (row.alertType === 'heart_rate_too_high_warning' || row.alertType === 'heart_rate_too_low_warning') {
              return this.$t(item.alertName) + `(${row.data}` + this.$t('heartRateUnit') + `)`
            } else if (row.alertType === 'blood_oxygen_too_low_warning') {
              return this.$t(item.alertName) + `(${row.data}%)`
            } else if (
              row.alertType === 'temperature_too_high_warning' ||
              row.alertType === 'temperature_too_low_warning'
            ) {
              return this.$t(item.alertName) + `(${row.data}℃)`
            } else if (row.alertType === 'fence_warning') {
              return this.$t(item.alertName) + `(${row.data})`
            }
          } else {
            return this.$t(item.alertName)
          }
        }
      }
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 查询列表
    getList() {
      this.currentPage = 1
      this.handleSearch()
    },
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        startTime: this.formInline.searchTimeB,
        endTime: this.formInline.searchTimeE,
        userName: this.formInline.userName,
        serialNumber: this.formInline.serialNumber,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        alertType: this.formInline.alertType,
        specType: this.formInline.specType,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        orderSort: {
          sortColName: this.formInline.sortColName,
          useAsc: this.formInline.useAsc,
        },
      }
      exportAlert(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('alertList') + '.xls')
      })
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.searchTimeB, this.formInline.searchTimeE)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.search()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.search()
      }
    },
    // 获取table数据
    search() {
      this.loading = true
      let params = {
        startTime: this.formInline.searchTimeB,
        endTime: this.formInline.searchTimeE,
        userName: this.formInline.userName,
        serialNumber: this.formInline.serialNumber,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        alertType: this.formInline.alertType,
        specType: this.formInline.specType,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        orderSort: {
          sortColName: this.formInline.sortColName,
          useAsc: this.formInline.useAsc,
        },
      }
      getCautionList(params).then(res => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.data.list
          this.totalData = res.data.total
        }
      })
    },
    // 点击操作成处理
    HandleClick(row) {
      if (row.status === 0) {
        let param = [row.id]
        this.$confirm(this.$t('handleAlertTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          updateStatus(param).then(res => {
            if (res.state === 0) {
              row.status = 1
              this.search()
            }
          })
        })
      }
    },
    // 一键全部处理告警
    dealAll() {
      this.$confirm(this.$t('handleAllAlertTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        clearMessage().then(res => {
          if (res.state === 0) {
            this.search()
          }
        })
      })
    },
    /**
     * 检查头盔类型
     */
    checkDeviceType(specType) {
      return localStorage.getItem('DEVICE_SPEC_TYPE').indexOf(specType + '') === -1 ? false : true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    // table 序号
    indexMethod(index) {
      return index + 1
    },
    // 用来查询的告警类型
    _findAlertType() {
      this.alertTypeList = []
      this.positionType = []
      findAlertType().then(res => {
        if (this.isOnlySupportPosition) {
          this.positionType.push({
            alertCode: 'fence_warning',
            alertName: '进入禁区',
          })
        } else {
          console.log(res.data,'res.data')
          this.positionType = res.data
        }
        this.alertTypeList = res.data
      })
    },
  },
  mounted() {
    this.getOusTree()
    this._findAlertType()
    this.search()
    if(this.$route.query && this.$route.query.currentPath) {this.showBack = true}
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl';
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 645px
  min-height 460px;/* no */
  overflow: auto
.base_main
  .breadcrumb-tilte
    position: relative
    .check_more
      position: absolute
      right: 15px
      top 50%
      transform: translate(0,-40%)
      text-align: center
      line-height: 28px
      padding: 0 7px
      border: 1px solid rgba(#5994C6,1)
      border-radius: 2px
      font-weight: bold
      color: #5994C6
      font-size: 14px
      border-radius: 4px;
      cursor pointer
  .title
    font-size 16px
    margin-bottom: 28px
  .common-table-cnt
    .user_input
      margin-top 10px
      width 100px
      margin-left 10px
    .el-button
      margin-left 10px
    .deal-btn
      color #0E65DD
      cursor pointer
      display inline-block
      width 24px
      height 24px
      -moz-background-size: 100% 100%
      background-size: 100% 100%
    .DealClass
      bg-image('~@/icon/deal.png')
    .unDealClass
      bg-image('~@/icon/unDeal.png')
    .ic-Deal
      bg-image('~@/icon/deal.png')
    .ic-unDeal
      bg-image('~@/icon/unDeal.png')
    .pagination
      float right
      margin-top 10px
  .linetwo
    display flex
    overflow hidden
    flex-direction row
    .leftColumn
      flex 0 0 50%
    .rightColumn
      flex 0 0 50%
>>>.el-popper
 min-width 100%!important
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 610px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
